// extracted by mini-css-extract-plugin
module.exports = {"ionContent":"style_ionContent__2SbUo","ionList":"style_ionList__2FOlb"};